export const gameId = 45

export const color = 0x000000

export const backEndVersion = 2
